import ApiModel from './ApiModel'

class storiesChapters extends ApiModel {
}

export default new storiesChapters('/stories-chapters');